module.exports = __webpack_public_path__ + "img/7.12a4d2c5.png";